module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer-dep",
    attrs: {
      "role": "contentinfo"
    }
  }, [_c('div', {
    staticClass: "container-fluid dep-contact",
    attrs: {
      "itemscope": "",
      "itemtype": "http://schema.org/Organization"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo-anjou",
    attrs: {
      "itemprop": "logo"
    }
  }, [_c('span', {
    staticClass: "dep49-icon-logo-anjou icon-logo-anjou-footer",
    attrs: {
      "aria-hidden": "true",
      "data-glyph": "icon-logo-anjou",
      "title": "Département de Maine-et-Loire - Anjou"
    }
  })]), _vm._v(" "), _c('address', {
    attrs: {
      "itemprop": "contactPoints"
    }
  }, [_c('p', [_c('strong', {
    attrs: {
      "itemprop": "name"
    }
  }, [_vm._v("Département de Maine-et-Loire")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "itemprop": "address"
    }
  }, [_vm._v("\n            CS 94104"), _c('br'), _vm._v("\n            49941 Angers Cedex 9\n          ")])]), _vm._v(" "), _c('p', {
    staticClass: "dep-telephone"
  }, [_c('a', {
    attrs: {
      "href": "https://www.maine-et-loire.fr",
      "itemprop": "url"
    }
  }, [_vm._v("maine-et-loire.fr")]), _vm._v(" "), _c('span', {
    attrs: {
      "itemprop": "telephone"
    }
  }, [_c('a', {
    attrs: {
      "href": "tel:+0241814949",
      "title": "Appeler le Département par téléphone au 02 41 81 49 49"
    }
  }, [_vm._v("02 41 81 49 49")])])])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://www.maine-et-loire.fr/contacter-le-departement/",
      "target": "_blank",
      "title": "Département de Maine-et-Loire - Anjou : aller au formulaire de contact du site maine-et-loire.fr (Nouvelle fenêtre)"
    }
  }, [_vm._v("Contactez le Département")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-808fa33e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Footer.vue
// module id = 23
// module chunks = 0